 export const HealthStatusType = Object.freeze(
    {
        OK: {id: "OK", label: "Ok", labelColor: "black", color: "black", backgroundColor: "lightgreen", iconColor: "green"},
        WARNING: {id: "WARNING", label: "Warning", labelColor: "black", color: "black", backgroundColor: "lightyellow", iconColor: "yellow"},
        ERROR: {id: "ERROR", label: "Error", labelColor: "black", color: "yellow", backgroundColor: "lightred", iconColor: "red"},
        UNKNOWN: {id: "UNKNOWN", label: "Unknown", labelColor: "black", color: "lightgrey", backgroundColor: "lightgrey", iconColor: "lightgrey"}
    }
)